/* eslint-disable max-len */
import { ScalpSeverityLanguageCopy } from '../services/concern-detections-service/concern-detections.constants';

export const scalpSeverityCopy: { [language: string]: ScalpSeverityLanguageCopy } = {
  en: {
    titles: {
      Normal: 'No signs of hair loss yet',
      Mild: 'Early-stage hair loss detected',
      Moderate: 'Scalp visibility increasing',
      Severe: 'Advanced-stage hair loss',
      Unknown: 'Scalp visibility detected',
    },
    descriptions: {
      Female: {
        Normal: 'You have healthy hair density, with no visible scalp or thinning. This is the easiest time to protect it — the right hair care routine can help keep it this way for years.',
        Mild: 'You have slight widening along the partition — the first sign of thinning. At this stage, hair fall is easiest to slow or reverse. Start treatment now to protect your density.',
        Moderate: 'You have noticeable widening along the partition, extending toward the hairline and crown. This stage tends to progress without treatment. Start now to stop it going further.',
        Severe: 'You have significant scalp visibility across the partition and crown. This stage is harder to reverse, but consistent treatment can still slow it and often regrow some density.',
        Unknown: 'You have visible scalp area along your hairline — a sign of hair thinning. This stage can progress without treatment. Start now to stop it going further.',
      },
      Male: {
        Normal: 'You have healthy density at the crown and hairline, with no visible scalp or thinning. This is the easiest time to protect it — the right hair care routine can help keep it this way for years.',
        Mild: 'You have slight thinning at the crown — an early sign of hair loss. At this stage, hair fall is easiest to slow or reverse. Start treatment now to protect your density.',
        Moderate: 'You have noticeable thinning at the crown, extending toward the hairline. This stage tends to progress without treatment. Start now to stop it going further.',
        Severe: 'You have significant scalp visibility across the crown and hairline. This stage is harder to reverse, but consistent treatment can still slow it and often regrow some density.',
        Unknown: 'You have visible scalp area at the crown and in front — a sign of hair loss. This stage can progress without treatment. Start now to stop it going further.',
      },
    },
    noDetection: {
      title: "Couldn't detect your scalp area",
      reasonsHeading: 'Possible reasons:',
      reasons: [
        'Top of head not fully in frame',
        'Photo is blurry or unclear',
        'Lighting is too low or too bright',
      ],
    },
  },
  hi: {
    titles: {
      Normal: 'अभी बाल झड़ने के कोई संकेत नहीं हैं',
      Mild: 'शुरुआती हेयर लॉस के संकेत मिले',
      Moderate: 'स्कैल्प ज़्यादा दिखाई दे रहा है',
      Severe: 'बढ़ा हुआ हेयर लॉस',
      Unknown: 'स्कैल्प दिखाई दे रहा है',
    },
    descriptions: {
      Female: {
        Normal: 'आपके बालों का घनापन अच्छा है। स्कैल्प कहीं से भी दिखाई नहीं दे रहा और बाल पतले होने के संकेत नहीं हैं। सही हेयर केयर रूटीन अपनाकर आप इन्हें लंबे समय तक स्वस्थ रख सकते हैं।',
        Mild: 'आपकी मांग थोड़ी चौड़ी दिख रही है, जो बाल पतले होने का शुरुआती संकेत है। इस चरण में हेयर लॉस को रोकना या कम करना सबसे आसान होता है। बालों का घनापन बनाए रखने के लिए अभी इलाज शुरू करें।',
        Moderate: 'आपकी मांग काफ़ी चौड़ी हो गई है और यह हेयरलाइन व सिर के बीच वाले हिस्से तक बढ़ रही है। बिना इलाज के यह समस्या बढ़ सकती है। इसे रोकने के लिए अभी इलाज शुरू करें।',
        Severe: 'आपकी मांग और सिर के बीच वाले हिस्से में स्कैल्प साफ़ दिखाई दे रहा है। इस चरण में सुधार मुश्किल हो सकता है, लेकिन नियमित इलाज से हेयर लॉस कम किया जा सकता है और बालों का कुछ घनापन वापस लाया जा सकता है।',
        Unknown: 'आपकी हेयरलाइन पर स्कैल्प दिखाई दे रहा है, जो बाल पतले होने का संकेत है। बिना इलाज के यह समस्या बढ़ सकती है। इसे आगे बढ़ने से रोकने के लिए अभी इलाज शुरू करें।',
      },
      Male: {
        Normal: 'आपके सिर के बीच वाले हिस्से और हेयरलाइन पर बालों का घनापन अच्छा है। स्कैल्प कहीं से भी दिखाई नहीं दे रहा और बाल पतले होने के संकेत नहीं हैं। सही हेयर केयर रूटीन अपनाकर आप इन्हें लंबे समय तक स्वस्थ रख सकते हैं।',
        Mild: 'सिर के बीच वाले हिस्से में बाल थोड़े पतले होने लगे हैं। यह हेयर लॉस का शुरुआती संकेत है। इस चरण में हेयर लॉस को रोकना या कम करना सबसे आसान होता है। बालों का घनापन बनाए रखने के लिए अभी इलाज शुरू करें।',
        Moderate: 'सिर के बीच वाले हिस्से में बाल काफ़ी पतले हो गए हैं और यह हेयरलाइन तक बढ़ रहा है। बिना इलाज के यह समस्या बढ़ सकती है। इसे रोकने के लिए अभी इलाज शुरू करें।',
        Severe: 'सिर के बीच वाले हिस्से और हेयरलाइन पर स्कैल्प साफ़ दिखाई दे रहा है। इस चरण में सुधार मुश्किल हो सकता है, लेकिन नियमित इलाज से हेयर लॉस कम किया जा सकता है और बालों का कुछ घनापन वापस लाया जा सकता है।',
        Unknown: 'सिर के बीच वाले हिस्से और आगे की तरफ़ स्कैल्प दिखाई दे रहा है, जो हेयर लॉस का संकेत है। बिना इलाज के यह समस्या बढ़ सकती है। इसे आगे बढ़ने से रोकने के लिए अभी इलाज शुरू करें।',
      },
    },
    noDetection: {
      title: 'स्कैल्प का सही आकलन नहीं हो सका',
      reasonsHeading: 'संभावित कारण:',
      reasons: [
        'सिर का ऊपरी हिस्सा पूरी तरह फोटो में नहीं है',
        'फोटो धुंधली या साफ़ नहीं है',
        'रोशनी बहुत कम या बहुत ज़्यादा है',
      ],
    },
  },
  mr: {
    titles: {
      Normal: 'अजून केसगळतीची चिन्हे नाहीत',
      Mild: 'सुरुवातीच्या केसगळतीची चिन्हे दिसत आहेत',
      Moderate: 'टाळू अधिक दिसू लागला आहे',
      Severe: 'प्रगत टप्प्यातील केसगळती',
      Unknown: 'टाळू दिसत आहे',
    },
    descriptions: {
      Female: {
        Normal: 'तुमच्या केसांची घनता चांगली आहे. टाळू दिसत नाही आणि केस पातळ होण्याची चिन्हे नाहीत. योग्य हेअर केअर रूटीनमुळे केस अनेक वर्षे असेच निरोगी राहू शकतात.',
        Mild: 'तुमच्या भांगेची रुंदी थोडी वाढलेली दिसत आहे, जे केस पातळ होण्याचं सुरुवातीचं लक्षण आहे. या टप्प्यावर उपचार सुरू केल्यास केसगळती थांबवणं सोपं असतं.',
        Moderate: 'तुमच्या भांगेची रुंदी स्पष्टपणे वाढली असून ती हेअरलाइन आणि डोक्याच्या मधल्या भागापर्यंत पसरत आहे. उपचारांशिवाय ही समस्या वाढत जाते. आजच उपचार सुरू करा.',
        Severe: 'तुमच्या भांगेत आणि डोक्याच्या मधल्या भागात टाळू स्पष्ट दिसत आहे. या टप्प्यावर पूर्ण सुधारणा कठीण असली तरी नियमित उपचारांनी केसगळती कमी होऊन काही प्रमाणात घनता परत मिळू शकते.',
        Unknown: 'तुमच्या हेअरलाइनजवळ टाळू दिसत आहे, जे केस पातळ होण्याचं लक्षण आहे. उपचार न घेतल्यास ही समस्या वाढू शकते. ती थांबवण्यासाठी आजच उपचार सुरू करा.',
      },
      Male: {
        Normal: 'डोक्याच्या मधल्या भागात आणि हेअरलाइनवर केसांची घनता चांगली आहे. टाळू दिसत नाही आणि केस पातळ होण्याची चिन्हे नाहीत. योग्य हेअर केअर रूटीनमुळे केस अनेक वर्षे असेच निरोगी राहू शकतात.',
        Mild: 'डोक्याच्या मधल्या भागात केस थोडे पातळ झाले आहेत. हे केसगळतीचं सुरुवातीचं लक्षण आहे. या टप्प्यावर उपचार सुरू केल्यास केसगळती थांबवणं सोपं असतं.',
        Moderate: 'डोक्याच्या मधल्या भागातील केस स्पष्टपणे पातळ झाले असून ते हेअरलाइनपर्यंत पसरत आहेत. उपचारांशिवाय ही समस्या वाढत जाते. आजच उपचार सुरू करा.',
        Severe: 'डोक्याच्या मधल्या भागात आणि हेअरलाइनवर टाळू स्पष्ट दिसत आहे. या टप्प्यावर पूर्ण सुधारणा कठीण असली तरी नियमित उपचारांनी केसगळती कमी होऊन काही प्रमाणात घनता परत मिळू शकते.',
        Unknown: 'डोक्याच्या मधल्या भागात आणि पुढच्या बाजूला टाळू दिसत आहे, जे केसगळतीचं लक्षण आहे. उपचार न घेतल्यास ही समस्या वाढू शकते. ती थांबवण्यासाठी आजच उपचार सुरू करा.',
      },
    },
    noDetection: {
      title: 'तुमचा टाळू ओळखता आला नाही',
      reasonsHeading: 'संभाव्य कारणे:',
      reasons: [
        'डोक्याचा वरचा भाग पूर्णपणे फोटोमध्ये नाही',
        'फोटो धूसर किंवा स्पष्ट नाही',
        'प्रकाश खूप कमी किंवा खूप जास्त आहे',
      ],
    },
  },
  te: {
    titles: {
      Normal: 'ప్రస్తుతం జుట్టు రాలే లక్షణాలు లేవు',
      Mild: 'ప్రారంభ దశ జుట్టు రాలడం గుర్తించబడింది',
      Moderate: 'తల చర్మం ఎక్కువగా కనిపిస్తోంది',
      Severe: 'ముదిరిన దశలో జుట్టు రాలడం',
      Unknown: 'తల చర్మం కనిపిస్తోంది',
    },
    descriptions: {
      Female: {
        Normal: 'మీ జుట్టు సాంద్రత బాగుంది. తల చర్మం కనిపించడం లేదు, జుట్టు పలుచబడిన లక్షణాలు కూడా లేవు. సరైన హెయిర్ కేర్‌తో దీన్ని చాలా కాలం అలాగే ఉంచుకోవచ్చు.',
        Mild: 'మీ జుట్టు మధ్య భాగం కొద్దిగా వెడల్పైంది. ఇది జుట్టు పలుచబడే తొలి సంకేతం. ఈ దశలో చికిత్స ప్రారంభిస్తే జుట్టు రాలడాన్ని తగ్గించడం సులభం.',
        Moderate: 'మీ జుట్టు మధ్య భాగం స్పష్టంగా వెడల్పై, హెయిర్‌లైన్ మరియు క్రౌన్ వరకు విస్తరించింది. చికిత్స లేకపోతే ఇది మరింత పెరుగుతుంది. ఇప్పుడే చికిత్స ప్రారంభించండి.',
        Severe: 'మీ జుట్టు మధ్య భాగం మరియు క్రౌన్ వద్ద తల చర్మం స్పష్టంగా కనిపిస్తోంది. ఈ దశలో పూర్తిగా తిరిగి రావడం కష్టమైనా, క్రమం తప్పని చికిత్సతో జుట్టు రాలడాన్ని తగ్గించి కొంత సాంద్రతను తిరిగి పొందవచ్చు.',
        Unknown: 'మీ హెయిర్‌లైన్ వద్ద తల చర్మం కనిపిస్తోంది. ఇది జుట్టు పలుచబడుతున్న సంకేతం. చికిత్స లేకపోతే ఇది మరింత పెరుగుతుంది. ఇప్పుడే చికిత్స ప్రారంభించండి.',
      },
      Male: {
        Normal: 'మీ క్రౌన్ మరియు హెయిర్‌లైన్ వద్ద జుట్టు సాంద్రత బాగుంది. తల చర్మం కనిపించడం లేదు, జుట్టు పలుచబడిన లక్షణాలు కూడా లేవు. సరైన హెయిర్ కేర్‌తో దీన్ని చాలా కాలం అలాగే ఉంచుకోవచ్చు.',
        Mild: 'మీ క్రౌన్ వద్ద జుట్టు కొద్దిగా పలుచబడింది. ఇది జుట్టు రాలే ప్రారంభ సంకేతం. ఈ దశలో చికిత్స ప్రారంభిస్తే జుట్టు రాలడాన్ని తగ్గించడం సులభం.',
        Moderate: 'మీ క్రౌన్ వద్ద జుట్టు స్పష్టంగా పలుచబడి, హెయిర్‌లైన్ వరకు విస్తరించింది. చికిత్స లేకపోతే ఇది మరింత పెరుగుతుంది. ఇప్పుడే చికిత్స ప్రారంభించండి.',
        Severe: 'మీ క్రౌన్ మరియు హెయిర్‌లైన్ వద్ద తల చర్మం స్పష్టంగా కనిపిస్తోంది. ఈ దశలో పూర్తిగా తిరిగి రావడం కష్టమైనా, క్రమం తప్పని చికిత్సతో జుట్టు రాలడాన్ని తగ్గించి కొంత సాంద్రతను తిరిగి పొందవచ్చు.',
        Unknown: 'మీ క్రౌన్ మరియు ముందు భాగంలో తల చర్మం కనిపిస్తోంది. ఇది జుట్టు రాలుతున్న సంకేతం. చికిత్స లేకపోతే ఇది మరింత పెరుగుతుంది. ఇప్పుడే చికిత్స ప్రారంభించండి.',
      },
    },
    noDetection: {
      title: 'మీ తల చర్మాన్ని సరిగా గుర్తించలేకపోయాము',
      reasonsHeading: 'ఇది జరగడానికి కారణాలు:',
      reasons: [
        'తల పైభాగం పూర్తిగా ఫ్రేమ్‌లో లేదు',
        'ఫోటో మసకగా లేదా స్పష్టంగా లేదు',
        'వెలుతురు చాలా తక్కువగా లేదా చాలా ఎక్కువగా ఉంది',
      ],
    },
  },
  kn: {
    titles: {
      Normal: 'ಇನ್ನೂ ಕೂದಲು ಉದುರುವ ಲಕ್ಷಣಗಳಿಲ್ಲ',
      Mild: 'ಆರಂಭಿಕ ಹಂತದ ಕೂದಲು ಉದುರುವಿಕೆ ಕಂಡುಬಂದಿದೆ',
      Moderate: 'ತಲೆಚರ್ಮ ಹೆಚ್ಚು ಕಾಣಿಸುತ್ತಿದೆ',
      Severe: 'ಮುನ್ನಡೆದ ಹಂತದ ಕೂದಲು ಉದುರುವಿಕೆ',
      Unknown: 'ತಲೆಚರ್ಮ ಕಾಣಿಸುತ್ತಿದೆ',
    },
    descriptions: {
      Female: {
        Normal: 'ನಿಮ್ಮ ಕೂದಲಿನ ದಟ್ಟತೆ ಉತ್ತಮವಾಗಿದೆ. ತಲೆಚರ್ಮ ಕಾಣಿಸುವುದಿಲ್ಲ ಮತ್ತು ಕೂದಲು ತೆಳುವಾಗುವ ಲಕ್ಷಣಗಳಿಲ್ಲ. ಸರಿಯಾದ ಕೂದಲು ಆರೈಕೆಯಿಂದ ಇದನ್ನು ಹಲವು ವರ್ಷಗಳವರೆಗೆ ಹಾಗೆಯೇ ಉಳಿಸಬಹುದು.',
        Mild: 'ನಿಮ್ಮ ಕೂದಲಿನ ಮಧ್ಯಭಾಗ ಸ್ವಲ್ಪ ಅಗಲವಾಗಿದೆ. ಇದು ಕೂದಲು ತೆಳುವಾಗುವ ಆರಂಭಿಕ ಲಕ್ಷಣ. ಈಗಲೇ ಚಿಕಿತ್ಸೆ ಆರಂಭಿಸಿದರೆ ಕೂದಲು ಉದುರುವಿಕೆಯನ್ನು ನಿಯಂತ್ರಿಸುವುದು ಸುಲಭ.',
        Moderate: 'ನಿಮ್ಮ ಕೂದಲಿನ ಮಧ್ಯಭಾಗ ಅಗಲವಾಗಿ ಹೇರ್‌ಲೈನ್ ಮತ್ತು ತಲೆಯ ಮೇಲ್ಭಾಗದವರೆಗೆ ಹರಡಿದೆ. ಚಿಕಿತ್ಸೆ ಇಲ್ಲದೆ ಇದು ಇನ್ನಷ್ಟು ಹೆಚ್ಚಾಗಬಹುದು. ಈಗಲೇ ಚಿಕಿತ್ಸೆ ಆರಂಭಿಸಿ.',
        Severe: 'ನಿಮ್ಮ ಕೂದಲಿನ ಮಧ್ಯಭಾಗ ಮತ್ತು ತಲೆಯ ಮೇಲ್ಭಾಗದಲ್ಲಿ ತಲೆಚರ್ಮ ಸ್ಪಷ್ಟವಾಗಿ ಕಾಣಿಸುತ್ತಿದೆ. ಈ ಹಂತದಲ್ಲಿ ಸಂಪೂರ್ಣವಾಗಿ ಸುಧಾರಿಸುವುದು ಕಷ್ಟವಾದರೂ, ನಿಯಮಿತ ಚಿಕಿತ್ಸೆಯಿಂದ ಉದುರುವಿಕೆಯನ್ನು ಕಡಿಮೆ ಮಾಡಿ ಕೆಲವು ದಟ್ಟತೆಯನ್ನು ಮರಳಿ ಪಡೆಯಬಹುದು.',
        Unknown: 'ನಿಮ್ಮ ಹೇರ್‌ಲೈನ್ ಬಳಿ ತಲೆಚರ್ಮ ಕಾಣಿಸುತ್ತಿದೆ. ಇದು ಕೂದಲು ತೆಳುವಾಗುತ್ತಿರುವ ಲಕ್ಷಣವಾಗಿದೆ. ಚಿಕಿತ್ಸೆ ಇಲ್ಲದೆ ಇದು ಇನ್ನಷ್ಟು ಹೆಚ್ಚಾಗಬಹುದು. ಈಗಲೇ ಚಿಕಿತ್ಸೆ ಆರಂಭಿಸಿ.',
      },
      Male: {
        Normal: 'ನಿಮ್ಮ ತಲೆಯ ಮೇಲ್ಭಾಗ ಮತ್ತು ಹೇರ್‌ಲೈನ್‌ನಲ್ಲಿ ಕೂದಲಿನ ದಟ್ಟತೆ ಉತ್ತಮವಾಗಿದೆ. ತಲೆಚರ್ಮ ಕಾಣಿಸುವುದಿಲ್ಲ ಮತ್ತು ಕೂದಲು ತೆಳುವಾಗುವ ಲಕ್ಷಣಗಳಿಲ್ಲ. ಸರಿಯಾದ ಕೂದಲು ಆರೈಕೆಯಿಂದ ಇದನ್ನು ಹಲವು ವರ್ಷಗಳವರೆಗೆ ಹಾಗೆಯೇ ಉಳಿಸಬಹುದು.',
        Mild: 'ನಿಮ್ಮ ತಲೆಯ ಮೇಲ್ಭಾಗದಲ್ಲಿ ಕೂದಲು ಸ್ವಲ್ಪ ತೆಳುವಾಗಿದೆ. ಇದು ಕೂದಲು ಉದುರುವ ಆರಂಭಿಕ ಲಕ್ಷಣವಾಗಿದೆ. ಈಗಲೇ ಚಿಕಿತ್ಸೆ ಆರಂಭಿಸಿದರೆ ಕೂದಲು ಉದುರುವಿಕೆಯನ್ನು ನಿಯಂತ್ರಿಸುವುದು ಸುಲಭ.',
        Moderate: 'ನಿಮ್ಮ ತಲೆಯ ಮೇಲ್ಭಾಗದಲ್ಲಿ ಕೂದಲು ಸ್ಪಷ್ಟವಾಗಿ ತೆಳುವಾಗಿ ಹೇರ್‌ಲೈನ್‌ವರೆಗೆ ಹರಡಿದೆ. ಚಿಕಿತ್ಸೆ ಇಲ್ಲದೆ ಇದು ಇನ್ನಷ್ಟು ಹೆಚ್ಚಾಗಬಹುದು. ಈಗಲೇ ಚಿಕಿತ್ಸೆ ಆರಂಭಿಸಿ.',
        Severe: 'ನಿಮ್ಮ ತಲೆಯ ಮೇಲ್ಭಾಗ ಮತ್ತು ಹೇರ್‌ಲೈನ್‌ನಲ್ಲಿ ತಲೆಚರ್ಮ ಸ್ಪಷ್ಟವಾಗಿ ಕಾಣಿಸುತ್ತಿದೆ. ಈ ಹಂತದಲ್ಲಿ ಸಂಪೂರ್ಣವಾಗಿ ಸುಧಾರಿಸುವುದು ಕಷ್ಟವಾದರೂ, ನಿಯಮಿತ ಚಿಕಿತ್ಸೆಯಿಂದ ಉದುರುವಿಕೆಯನ್ನು ಕಡಿಮೆ ಮಾಡಿ ಕೆಲವು ದಟ್ಟತೆಯನ್ನು ಮರಳಿ ಪಡೆಯಬಹುದು.',
        Unknown: 'ನಿಮ್ಮ ತಲೆಯ ಮೇಲ್ಭಾಗ ಮತ್ತು ಮುಂಭಾಗದಲ್ಲಿ ತಲೆಚರ್ಮ ಕಾಣಿಸುತ್ತಿದೆ. ಇದು ಕೂದಲು ಉದುರುವ ಲಕ್ಷಣವಾಗಿದೆ. ಚಿಕಿತ್ಸೆ ಇಲ್ಲದೆ ಇದು ಇನ್ನಷ್ಟು ಹೆಚ್ಚಾಗಬಹುದು. ಈಗಲೇ ಚಿಕಿತ್ಸೆ ಆರಂಭಿಸಿ.',
      },
    },
    noDetection: {
      title: 'ನಿಮ್ಮ ತಲೆಚರ್ಮವನ್ನು ಸರಿಯಾಗಿ ಗುರುತಿಸಲು ಸಾಧ್ಯವಾಗಲಿಲ್ಲ',
      reasonsHeading: 'ಸಂಭವ್ಯ ಕಾರಣಗಳು:',
      reasons: [
        'ತಲೆಯ ಮೇಲ್ಭಾಗ ಸಂಪೂರ್ಣವಾಗಿ ಫ್ರೇಮ್‌ನಲ್ಲಿ ಇಲ್ಲ',
        'ಫೋಟೋ ಮಸುಕಾಗಿದೆ ಅಥವಾ ಸ್ಪಷ್ಟವಾಗಿಲ್ಲ',
        'ಬೆಳಕು ತುಂಬಾ ಕಡಿಮೆ ಅಥವಾ ತುಂಬಾ ಹೆಚ್ಚು ಇದೆ',
      ],
    },
  },
  ta: {
    titles: {
      Normal: 'இன்னும் முடி உதிர்வுக்கான அறிகுறிகள் இல்லை',
      Mild: 'ஆரம்ப நிலை முடி உதிர்வு கண்டறியப்பட்டது',
      Moderate: 'தலைச்சருமம் அதிகமாக தெரிகிறது',
      Severe: 'முன்னேறிய நிலை முடி உதிர்வு',
      Unknown: 'தலைச்சருமம் தெரிகிறது',
    },
    descriptions: {
      Female: {
        Normal: 'உங்கள் முடியின் அடர்த்தி நன்றாக உள்ளது. தலைச்சருமம் தெரியவில்லை, முடி மெலிவதற்கான அறிகுறிகளும் இல்லை. சரியான பராமரிப்பால் இதை பல ஆண்டுகள் ஆரோக்கியமாக வைத்திருக்கலாம்.',
        Mild: 'உங்கள் முடி வகிடு சற்று அகலமாகியுள்ளது. இது முடி மெலிவதற்கான ஆரம்ப அறிகுறி. இந்த நிலையில் சிகிச்சையைத் தொடங்கினால் முடி உதிர்வை எளிதாகக் கட்டுப்படுத்தலாம்.',
        Moderate: 'உங்கள் முடி வகிடு கணிசமாக அகலமாகி, முடி வரி மற்றும் தலையின் மேல்பகுதி வரை பரவியுள்ளது. சிகிச்சை இல்லையெனில் இது மேலும் மோசமடையும். இப்போதே சிகிச்சையைத் தொடங்குங்கள்.',
        Severe: 'உங்கள் முடி வகிடு மற்றும் தலையின் மேல்பகுதியில் தலைச்சருமம் தெளிவாக தெரிகிறது. இந்த நிலையில் முழுமையாக மாற்றுவது சற்று கடினம். இருப்பினும், தொடர்ந்து சிகிச்சை எடுத்தால் முடி உதிர்வை குறைத்து ஓரளவு அடர்த்தியை மீட்டெடுக்கலாம்.',
        Unknown: 'உங்கள் முடி வரியில் தலைச்சருமம் தெரிகிறது. இது முடி மெலிவதற்கான அறிகுறி. சிகிச்சை இல்லையெனில் இது மேலும் மோசமடையும். இப்போதே சிகிச்சையைத் தொடங்குங்கள்.',
      },
      Male: {
        Normal: 'உங்கள் தலையின் மேல்பகுதி மற்றும் முடி வரியில் நல்ல அடர்த்தி உள்ளது. தலைச்சருமம் தெரியவில்லை; முடி மெலிவதற்கான அறிகுறிகளும் இல்லை. சரியான பராமரிப்பால் இதை பல ஆண்டுகள் ஆரோக்கியமாக வைத்திருக்கலாம்.',
        Mild: 'உங்கள் தலையின் மேல்பகுதியில் முடி சற்று மெலிந்துள்ளது. இது முடி உதிர்வின் ஆரம்ப அறிகுறியாகும். இந்த நிலையில் சிகிச்சையைத் தொடங்கினால் முடி உதிர்வை எளிதாகக் கட்டுப்படுத்தலாம்.',
        Moderate: 'உங்கள் தலையின் மேல்பகுதியில் முடி கணிசமாக மெலிந்து, முடி வரி வரை பரவியுள்ளது. சிகிச்சை இல்லையெனில் இது மேலும் மோசமடையும். இப்போதே சிகிச்சையைத் தொடங்குங்கள்.',
        Severe: 'உங்கள் தலையின் மேல்பகுதி மற்றும் முடி வரியில் தலைச்சருமம் தெளிவாக தெரிகிறது. இந்த நிலையில் முழுமையாக மாற்றுவது சற்று கடினம். இருப்பினும், தொடர்ந்து சிகிச்சை எடுத்தால் முடி உதிர்வை குறைத்து ஓரளவு அடர்த்தியை மீட்டெடுக்கலாம்.',
        Unknown: 'உங்கள் தலையின் மேல்பகுதியிலும் முன்பகுதியிலும் தலைச்சருமம் தெரிகிறது. இது முடி உதிர்வின் அறிகுறி. சிகிச்சை இல்லையெனில் இது மேலும் மோசமடையும். இப்போதே சிகிச்சையைத் தொடங்குங்கள்.',
      },
    },
    noDetection: {
      title: 'உங்கள் தலைச்சருமத்தை சரியாக கண்டறிய முடியவில்லை',
      reasonsHeading: 'இதற்கான காரணங்கள்:',
      reasons: [
        'தலையின் மேற்பகுதி முழுமையாக படத்தில் இல்லை',
        'புகைப்படம் மங்கலாக அல்லது தெளிவாக இல்லை',
        'ஒளி மிகவும் குறைவாக அல்லது மிகவும் அதிகமாக உள்ளது',
      ],
    },
  },
  bn: {
    titles: {
      Normal: 'এখনও চুল পড়ার কোনো লক্ষণ নেই',
      Mild: 'প্রাথমিক পর্যায়ের চুল পড়া ধরা পড়েছে',
      Moderate: 'মাথার ত্বক আরও বেশি দেখা যাচ্ছে',
      Severe: 'উন্নত পর্যায়ের চুল পড়া',
      Unknown: 'মাথার ত্বক দেখা যাচ্ছে',
    },
    descriptions: {
      Female: {
        Normal: 'আপনার চুলের ঘনত্ব ভালো রয়েছে। মাথার ত্বক দেখা যাচ্ছে না এবং চুল পাতলা হওয়ার লক্ষণও নেই। সঠিক যত্নে এই অবস্থাই বহু বছর ধরে বজায় রাখা সম্ভব।',
        Mild: 'আপনার সিঁথি একটু চওড়া হয়েছে, যা চুল পাতলা হওয়ার প্রথম লক্ষণ। এই পর্যায়ে চিকিৎসা শুরু করলে চুল পড়া সহজেই নিয়ন্ত্রণ করা যায়।',
        Moderate: 'আপনার সিঁথি অনেকটা চওড়া হয়ে হেয়ারলাইন ও মাথার উপরের অংশ পর্যন্ত ছড়িয়েছে। চিকিৎসা না করলে এটি আরও বাড়তে পারে। এখনই চিকিৎসা শুরু করুন।',
        Severe: 'আপনার সিঁথি ও মাথার উপরের অংশে মাথার ত্বক স্পষ্ট দেখা যাচ্ছে। এই পর্যায়ে পুরোপুরি আগের অবস্থায় ফিরিয়ে আনা কঠিন হলেও, নিয়মিত চিকিৎসায় চুল পড়া কমিয়ে কিছুটা ঘনত্ব ফিরিয়ে আনা সম্ভব।',
        Unknown: 'আপনার হেয়ারলাইনে মাথার ত্বক দেখা যাচ্ছে, যা চুল পাতলা হওয়ার লক্ষণ। চিকিৎসা না করলে এটি আরও বাড়তে পারে। এখনই চিকিৎসা শুরু করুন।',
      },
      Male: {
        Normal: 'মাথার উপরের অংশ ও হেয়ারলাইনে আপনার চুলের ঘনত্ব ভালো রয়েছে। মাথার ত্বক দেখা যাচ্ছে না এবং চুল পাতলা হওয়ার লক্ষণও নেই। সঠিক যত্নে এই অবস্থাই বহু বছর ধরে বজায় রাখা সম্ভব।',
        Mild: 'মাথার উপরের অংশে চুল সামান্য পাতলা হয়েছে। এটি চুল পড়ার প্রাথমিক লক্ষণ। এই পর্যায়ে চিকিৎসা শুরু করলে চুল পড়া সহজেই নিয়ন্ত্রণ করা যায়।',
        Moderate: 'মাথার উপরের অংশে চুল স্পষ্টভাবে পাতলা হয়ে হেয়ারলাইন পর্যন্ত ছড়িয়েছে। চিকিৎসা না করলে এটি আরও বাড়তে পারে। এখনই চিকিৎসা শুরু করুন।',
        Severe: 'মাথার উপরের অংশ ও হেয়ারলাইনে মাথার ত্বক স্পষ্ট দেখা যাচ্ছে। এই পর্যায়ে পুরোপুরি আগের অবস্থায় ফিরিয়ে আনা কঠিন হলেও, নিয়মিত চিকিৎসায় চুল পড়া কমিয়ে কিছুটা ঘনত্ব ফিরিয়ে আনা সম্ভব।',
        Unknown: 'আপনার মাথার উপরের অংশ ও সামনের দিকে মাথার ত্বক দেখা যাচ্ছে, যা চুল পড়ার লক্ষণ। চিকিৎসা না করলে এটি আরও বাড়তে পারে। এখনই চিকিৎসা শুরু করুন।',
      },
    },
    noDetection: {
      title: 'আপনার মাথার ত্বক সঠিকভাবে শনাক্ত করা যায়নি',
      reasonsHeading: 'সম্ভাব্য কারণ:',
      reasons: [
        'মাথার উপরের অংশ পুরোপুরি ছবিতে নেই',
        'ছবিটি ঝাপসা বা পরিষ্কার নয়',
        'আলো খুব কম বা খুব বেশি',
      ],
    },
  },
};
